module.exports = __webpack_public_path__ + "img/gxys.3670b8d.png";